import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../../options/services/options.service'
import { setPulsesOptions } from '../store/options.actions'

export function* getPulsesOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getPulsesOptions])
    const { entity } = response
    yield put(setPulsesOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getPulsesOptions() error: ${e}`))
  }
}

export function* getPulsesOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getPulsesOptions)
}
